export const getBuildingsDataByIds = (buildingIds = [], onSuccess = () => {}) => {
  fetch('/api/tile-server/buildings', {
    method: 'post',
    headers: {
      'Content-type': 'application/json',
      'X-CSRF-Token': window.csrf,
    },
    credentials: 'same-origin',
    body: JSON.stringify({
      buildingIds,
    }),
  })
    .then((res) => res.json())
    .then((json) => {
      onSuccess(json.buildings);
    })
    .catch((error) => {
      console.warn(error);
    });
};
